import { defineStore } from 'pinia';

export const useFloatingBannerStore = defineStore('floatingBanner', {
  state: () => ({
    activeBanner: null,
  }),
});
